import { onSupportSignal, SUPPORT_COPY, type SupportSignal } from "@healthos/client-data";
import { useEffect, useState } from "react";

/** Shown the moment a request carries a detection, wherever the member is. Copy is under clinical review. */
export function CrisisNotice() {
  const [kind, setKind] = useState<SupportSignal | null>(null);
  useEffect(() => {
    onSupportSignal(setKind);
    return () => onSupportSignal(null);
  }, []);
  if (!kind) return null;
  return (
    <div
      role="alert"
      className="fixed inset-x-0 top-0 z-[200] flex items-start justify-between gap-4 border-b border-navy/10 bg-white px-4 py-3 text-sm text-navy shadow-md"
    >
      <p>{SUPPORT_COPY[kind]}</p>
      <button
        type="button"
        onClick={() => setKind(null)}
        className="shrink-0 font-medium underline"
      >
        Close
      </button>
    </div>
  );
}
